const DueDateTypeEnum = {
  noDueDate: 'NO_DUE_DATE',
  dynamic: 'DYNAMIC',
  fixed: 'FIXED'
};

export { DueDateTypeEnum };
export default DueDateTypeEnum;
